import { render, staticRenderFns } from "./DeleteConfirmation.vue?vue&type=template&id=b51bf5e6&scoped=true"
import script from "./DeleteConfirmation.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51bf5e6",
  null
  
)

export default component.exports